// eslint-disable-next-line @typescript-eslint/no-explicit-any
function allWithFoodOrMealRule(family: any, atribute: string) {
  const includesYes = Boolean(
    family?.nutritionInfo?.[atribute].answer.includes('Sim')
  )

  return includesYes
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function allWithConsumptionRule(family: any, atribute: string): boolean {
  if (
    family.nutritionInfo?.[atribute].answer !== 'Não' &&
    family.nutritionInfo?.[atribute] !== 'não informado' &&
    family.nutritionInfo?.[atribute].answer === undefined
  )
    return false
  else if (
    allWithFoodOrMealRule(family, 'foodAvailabilityAfterCovid') &&
    allWithFoodOrMealRule(family, 'foodConcern') &&
    allWithFoodOrMealRule(family, 'foodDeficiency') &&
    allWithFoodOrMealRule(family, 'foodEndedEarly') &&
    allWithFoodOrMealRule(family, 'healthyFoodDeficiency') &&
    allWithFoodOrMealRule(family, 'skipedMeal')
  ) {
    return true
  } else return false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function nutritionRules(family: any, atribute: string): boolean {
  return atribute.includes('consumption')
    ? allWithConsumptionRule(family, atribute)
    : allWithFoodOrMealRule(family, atribute)
}
